import React from 'react'

import InputField from 'src/components/InputField'
import CheckBox   from 'src/components/CheckBox'

const SignUp = props =>
  <div>
    <div className="row gx-2">
      <div className="col-sm-6">
        <InputField
          {...props.inputProps('first_name')}
          required
          label="First Name"
          autoFocus
          autoComplete="given-name"
        />
      </div>
      <div className="col-sm-6">
        <InputField
          {...props.inputProps('last_name')}
          required
          label="Last Name"
          autoComplete="family-name"
        />
      </div>
    </div>

    <div className="row gx-2">
      <div className="col-sm-6">
        <InputField
          {...props.inputProps('password')}
          required
          label="Password"
          type="password"
          autoComplete="new-password"
        />
      </div>
      <div className="col-sm-6">
        <InputField
          {...props.inputProps('password_confirmation')}
          required
          label="Confirm Password"
          type="password"
          autoComplete="new-password"
        />
      </div>
    </div>

    { props.cobrand ? null :
      <div className="mb-3">
        <CheckBox
          {...props.booleanProps('newsletter_subscribed')}
          label="I would like to receive news &amp; product updates from Pledge"
        />
      </div>
    }
  </div>

export default SignUp
